export const EXSBMEASURE_DELETE_RESET = 'EXSBMEASURE_DELETE_RESET'
export const EXSBMEASURE_DELETE_SET_ERROR = 'EXSBMEASURE_DELETE_SET_ERROR'
export const EXSBMEASURE_DELETE_SET_DELETED = 'EXSBMEASURE_DELETE_SET_DELETED'
export const EXSBMEASURE_DELETE_TOGGLE_LOADING = 'EXSBMEASURE_DELETE_TOGGLE_LOADING'
